export default function Row({ children, className = "", ...props }) {
    return <div className={`flex flex-row justify-center flex-wrap ${className}`} {...props}>{children}</div>
}
